export const RECORDS_PER_PAGE = 5

export const INITIAL_PAGE = 1

export const ERROR_MESSAGE = 'Lo sentimos, ocurrió un error al ejecutar la acción.'

export const CUSTOM_ERROR_TITLES = {
  addParticipant: 'Error al incorporar el participante al listado'
}

export const PARTICIPANTS_ROLE = [
  {
    value: 1,
    name: 'Requirente de compra',
    alias: ''
  },
  {
    value: 2,
    name: 'Autorizador de la compra',
    alias: ''
  },
  {
    value: 3,
    name: 'Evaluador o comisión evaluadora',
    alias: ''
  },
  {
    value: 4,
    name: 'Administrador de contrato',
    alias: ''
  },
  {
    value: 5,
    name: 'Firmante',
    alias: ''
  }
]

export const PURCHASING_MECHANISM = [
  {
    value: 1,
    name: 'Gestión de contratos',
    groupName: 'Contrato',
    alias: 'Contrato'
  },
  {
    value: 2,
    name: 'Licitaciones L1',
    groupName: 'Mecanismo de Compra',
    alias: 'Licitación'
  },
  {
    value: 3,
    name: 'Cotizaciones',
    groupName: 'Mecanismo de Compra',
    alias: 'Cotización'
  },
  {
    value: 4,
    name: 'Compra Agil',
    groupName: 'Mecanismo de Compra',
    alias: 'Compra Agil'
  },
  {
    value: 5,
    name: 'Orden de compra',
    groupName: 'Orden de Compra',
    alias: 'Orden de compra'
  },
  {
    value: 6,
    name: 'Licitaciones - Mayor 100 UTM',
    groupName: 'Mecanismo de Compra',
    alias: 'Licitación'
  },
  {
    value: 7,
    name: 'Trato Directo',
    groupName: 'Mecanismo de Compra',
    alias: 'Trato Directo'
  },
  {
    value: 8,
    name: 'Orden De Compra De Trato Directo',
    groupName: 'Mecanismo de Compra',
    alias: 'Orden de compra de trato directo'
  },
  {
    value: 9,
    name: 'Contrato Para La Innovacion',
    groupName: 'Mecanismo de Compra',
    alias: 'Contrato para la innovación'
  },
  {
    value: 10,
    name: 'Dialogos Competitivos ',
    groupName: 'Mecanismo de Compra',
    alias: 'Diálogos competitivos'
  }
]

export const PURCHASING_MECHANISM_ACRONYMUS_DICTIONARY = {
  CT: 1,
  LC: 2,
  SC: 3,
  CA: 4,
  OC: 5,
  TD: 7,
  CI: 9,
  DC: 10
}

export const TENDERS_MAPPER = new Set(['L1', 'LE', 'LP', 'LQ', 'LR', 'O1', 'E2', 'CO', 'B2', 'H2', 'I2', 'O2', 'LS'])

export const EXCLUDED_PURCHASING_MECANISMS_IDS = new Set([3, 4, 6, 7, 8, 9, 10])

export const WRITE_ALLOWED_ROLES = {
  adminBuyer: 13,
  supervisorBuyer: 16
}

export const IS_MANUAL_CREATE_PROCESS = 1

export const EXCLUDED_ROLE_MESSAGE = '(NO INFORMADO)'

export const FALLBACK_TEXT_TABLE_MESSAGE = 'No informado'

export const ORGANIZATION_CODE_NOT_ALLOWED_ERROR_MESSAGE = 'Acceso denegado, organización no autorizada'

export const SERVICE_ORGANIZATION_INTERNAL_ERROR_MESSAGE =
  'Error al obtener la validación del usuario por código de organización.'

export const VALIDATION_PARTICIPANT_LIST_ERROR = [
  ORGANIZATION_CODE_NOT_ALLOWED_ERROR_MESSAGE,
  SERVICE_ORGANIZATION_INTERNAL_ERROR_MESSAGE
]

export const PATTERN_DATE = 'dd-MM-yyyy'

export const PATTERN_DATE_OUT = 'yyyy-MM-dd'

export const PATTERN_TIME_START_OUT = '00:00:00'

export const PATTERN_TIME_END_OUT = '23:59:59'
